import { render, staticRenderFns } from "./msgrs.vue?vue&type=template&id=21e44422&"
import script from "./msgrs.vue?vue&type=script&lang=ts&"
export * from "./msgrs.vue?vue&type=script&lang=ts&"
import style0 from "./msgrs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports